import { FormProvider, useForm } from "react-hook-form";
import StickyToolbar from "../../../../../Components/StickyToolbar";
import {
    IAtendimentoClienteRequest,
    TModoGestaoAtendimento,
} from "../../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faSort, faTimes } from "@fortawesome/free-solid-svg-icons";

interface IFiltroAtendimentoOrdenacao {
    atendimento: TModoGestaoAtendimento;
    filter: IAtendimentoClienteRequest | undefined;
    FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE: string | null;
    watchStatusCaso: string | undefined;
    setFilter: any;
    filtroOrdenacao: boolean;
    tipoAtendimento: TModoGestaoAtendimento;
    handleDateChange: (formData: any) => void;
    filtroInicial: any;
}

export default function FiltroAtendimentoOrdenacao(
    props: IFiltroAtendimentoOrdenacao
) {
    const FormMethods = useForm<{
        ORDER_BY: string;
        VL_DESC_ASC: string;
    }>();
    const { handleSubmit, register, reset } = FormMethods;

    const { filter, watchStatusCaso, handleDateChange } = props;

    return (
        <StickyToolbar icon={faSort} title="Filtro Ordenação" marginTop="-45px">
            <FormProvider {...FormMethods}>
                <form
                    className="form-group row"
                    onSubmit={handleSubmit(handleDateChange)}
                >
                    <div className="col-12 mt-3">
                        <label>Ordenar Por:</label>
                        <select
                            className="form-control"
                            name="ORDER_BY"
                            ref={register()}
                            defaultValue={filter?.ORDER_BY}
                        >
                            <option></option>
                            <option value="Data de início do caso">
                                Data de início do caso
                            </option>
                            {(watchStatusCaso === "Fechado" ||
                                watchStatusCaso === "Cancelado") && (
                                <option value="Data fim do caso">
                                    Data fim do caso
                                </option>
                            )}
                            <option value="Expectativa de Conclusão">
                                Expectativa de Conclusão
                            </option>
                            <option value="Dt. SLA">Dt. SLA</option>
                            <option value="Protocolo">Protocolo</option>
                            <option value="Data da última iteração">
                                Data da última iteração
                            </option>
                        </select>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Ordem de exibição:</label>
                        <select
                            className="form-control"
                            name="VL_DESC_ASC"
                            ref={register()}
                            defaultValue={String(filter?.VL_DESC_ASC) ?? "true"}
                        >
                            <option></option>
                            <option value="true">Decrescente</option>
                            <option value="false">Crescente</option>
                        </select>
                    </div>
                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={() => {
                                reset({
                                    ORDER_BY: "",
                                    VL_DESC_ASC: "",
                                });
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </form>
            </FormProvider>
        </StickyToolbar>
    );
}
